import Axios from '@/axios'

// 获取枚举
export const GetAdminWebEnums = () => {
  return Axios({
    url: '/device-manager/api/common/index_enums',
    method: 'POST',
    type: 'json'
  })
}
